
export default {
  // Home page
  "airport_rankings": "机场排名",
  "recent_reviews": "最新评论",
  "loading_reviews": "加载评论中...",
  "no_reviews": "暂无评论。",
  "share_experience": "分享您的体验",
  "help_photographers": "通过分享您在机场的体验来帮助其他胶片摄影师",
  "add_review": "添加评论",
  "loading_leaderboard": "加载排行榜中...",
  "no_reviews_yet": "暂无评论",
  "be_first": "成为第一个评价机场的人！",
  "best_airports": "最佳机场",
  "worst_airports": "最差机场",
  "success_rate": "成功率",
  "airport_name": "机场名称",
  "airport_location": "位置",
  "score": "评分",
  "total_reviews": "评论总数",
  "bottom_10_airports": "基于胶片摄影师评论的最差10个机场",
  "top_10_airports": "基于胶片摄影师评论的最佳10个机场",
  // Review tabs
  "all_reviews": "所有评论",
  "verified_reviews": "已验证评论",
  "no_verified_reviews": "暂无已验证评论。",
  "creative_reviews": "创意人士评论",
  "traveler_reviews": "旅行者评论",
  "no_creative_reviews": "暂无已验证创意人士的评论。",
  "no_traveler_reviews": "暂无已验证旅行者的评论。"
};
